import './product-tabbed-accordion.css';
import { trackPDPInfoClick } from 'utils/tracking';
import updateURL from '../utils/update-url';

export default (section) => {
  const init = () => {
    const getHeight = () => {
      const elementsDetails = section.querySelectorAll('[height-details]');
      const minHeight = 449;

      elementsDetails.forEach((element) => {
        if (element.clientHeight > minHeight) {
          element.classList.add('lg:pr-12');
        }
      });
    };

    getHeight();

    const tabs = document.querySelectorAll('[data-tab-product]');

    if (window.innerWidth > 1024) {
      document.querySelectorAll('details').forEach((e) => {
        e.setAttribute('open', '');
      });
    }

    const videoPreviewBtn = document.querySelectorAll('.video-preview-btn');

    videoPreviewBtn.forEach((btn) => {
      const initVideoPreviewBtn = (el) => {
        const parent = el.parentNode;
        parent.style.display = 'none';
        const sibling =
          parent.nextElementSibling.querySelector('[data-video-play]');
        sibling.click();
      };

      btn.addEventListener('click', () => {
        initVideoPreviewBtn(btn);
      });

      btn.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          initVideoPreviewBtn(btn);
        }
      });
    });

    const pauseTrigger = () => {
      const pauseElement = document.querySelectorAll('[data-video-play]');
      pauseElement.forEach((item) => {
        const firstChild = item.firstElementChild;
        if (firstChild.classList.contains('hidden')) {
          item.click();
        }
      });
    };

    const details = document.querySelectorAll('summary');

    details.forEach((det) => {
      det.addEventListener('touchstart', () => {
        pauseTrigger();
      });
    });

    const updateElement = (tabItems, event) => {
      const clickedElement = event.target;
      if (clickedElement.hasAttribute('data-tab')) {
        const clickedTab = clickedElement.getAttribute('data-tab');
        pauseTrigger();
        tabItems.forEach((tabItem) => {
          const tabItemDataTab = tabItem.getAttribute('data-tab');
          if (tabItemDataTab === clickedTab) {
            tabItem.classList.add('active');
            getHeight();
          } else {
            tabItem.classList.remove('active');
          }
        });

        trackPDPInfoClick({
          action: clickedElement.innerText?.toLowerCase(),
          text: clickedElement.innerText?.toLowerCase(),
        });
      }
    };

    tabs.forEach((tab) => {
      const tabItems = tab.querySelectorAll('[data-tab]');

      tab.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          updateElement(tabItems, event);
        }
      });
      tab.addEventListener('click', (event) => {
        updateElement(tabItems, event);
      });

      // track links click
      const links = tab.querySelectorAll('a');
      if (!links.length) return;

      links.forEach((link) =>
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const activeTab = section.querySelector('li[data-tab].active');
          trackPDPInfoClick({
            action: activeTab?.innerText?.toLowerCase(),
            text: link.innerText,
          });
          window.location = updateURL(link.href);
        }),
      );
    });
  };

  init();
};
